import React from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";

import Header from "../components/Header";
import Footer from "../components/Footer";

import "./index.css";
import "./custom.css"
import "./background.css";

/* david - importing custom fonts from npm installed packages */
require('typeface-muli');
require('typeface-open-sans');

if (typeof window !== 'undefined') {
  // Make scroll behavior of internal links smooth
  // eslint-disable-next-line global-require
  require('smooth-scroll')('a[href*="#"]');
}


//david - importing animation library
import "../../node_modules/aos/dist/aos.css"

import favicon from '../../src/images/logo.png'
import shareImage from '../../src/images/logo.png'


class TemplateWrapper extends React.Component {

  componentDidMount() {
    const AOS = require('aos');
    this.aos = AOS
    this.aos.init()
  }

  componentDidUpdate() {
      this.aos.refresh()
  }

  render() {
    const { location, children } = this.props
    let header
    const siteTitle = this.props.data.site.siteMetadata.title
    const siteDescription = this.props.data.site.siteMetadata.description
    const siteUrl = this.props.data.site.siteUrl

    return(
      <div className="flex flex-col font-sans min-h-screen text-grey-darkest antialiased">
        <Helmet>
          {/* Favicon */}
          <link rel="shortcut icon" href={favicon} />
          <title> {siteTitle} </title>

          {/* Google / Search Engine Tags */} 
          <meta itemprop="name" content={siteTitle}/>
          <meta itemprop="description" content={siteDescription}/>
          <meta itemprop="image" content={shareImage}/>

          {/* Facebook Open Graph Meta Tags */} 
          <meta property="og:url" content={siteUrl}/>
          <meta property="og:type" content="website"/>
          <meta property="og:title" content={siteTitle}/>
          <meta property="og:description" content={siteDescription}/>
          <meta property="og:image" content={shareImage}/>

          {/* Twitter Meta Tags */}
          <meta name="twitter:card" content="summary_large_image"/>
          <meta name="twitter:title" content={siteTitle}/>
          <meta name="twitter:description" content={siteDescription}/>
          <meta name="twitter:image" content={shareImage}/>

        </Helmet>
        <Header />
        { children() }
        <Footer />
      </div>
    );
  }
}

TemplateWrapper.propTypes = {
  children: PropTypes.func
};

export default TemplateWrapper;


export const pageQuery = graphql`
    query PageQuery {
        site {
            siteMetadata {
                title
                description
                siteUrl
            }
        }
    }
`


// WEBPACK FOOTER //
// ./src/layouts/index.js